export default {
  LANG_CODE: 'it',
  LANG_NOT_FOUND: 'Non stiamo supportando la lingua che stai cercando di selezionare.',
  LANG_HAS_DELETED: 'Non supportiamo la lingua selezionata, contatta il nostro team di assistenza.',
  USER_ID: 'ID utente',
  USER_NAME: 'Nome utente',
  PASSWORD: 'Password',
  REQUIRED_FIELD: 'è un campo obbligatorio',
  FORGOT_PASSWORD: 'Password dimenticata',
  API_DEFAULT_ERROR: 'Qualcosa è andato storto. Riprova tra qualche minuto..',
  SUPPORT_LABEL: 'per problemi di accesso o password contattare',
  BACK_TO_LOGIN: 'Torna al accesso',
  SUBMIT: 'Invia',
  YES: 'Sì',
  NO: 'No',
  DELETE: 'Eliminare',
  LOGOUT: 'Esci',
  LOGOUT_POPUP_TITLE: 'Vuoi uscire?',
  EVENT_INFO: "Informazioni sull'evento",
  QUALIFYING_QUESTIONS: 'Domande di qualificazione',
  CONTENT: 'Sommario',
  EMAILS: 'Emails',
  PREVIOUS: 'Precedente',
  CONTINUE: 'Continua',
  FINISH: 'Finitura',
  ADD: 'Aggiungi',
  CANCEL: 'Annullare',
  APPROVE: 'Approva',
  INVALID_FIELD: 'Il campo non è valido',
  SET: 'Imposta',
  EXHIBITORS: 'Espositori',
  EVENT_ID: 'Id evento',
  PASS_MIN_LEN_ERROR: 'Deve contenere almeno 6 caratteri.',
  SAVE: 'Salvare',
  EDIT: 'Modificare',
  COOCKIE_POLICY: 'Informativa sui cookie',
  COOCKIE_TEXT:
    "I cookie ci aiutano a fornire i nostri servizi. Utilizziamo i cookie per offrirti la miglior esperienza possibile sul nostro sito web. Chiudendo questa finestra o continuando a utilizzare il sito, accettate l'utilizzo di tali cookie da parte nostra. Scoprilo nel nostro",
  COOCKIE_POLICY_LINK: 'https://fielddrive.com/cookie-policy/',
  SUCCESS_TITLE: 'Operazione completata!',
  FAILED_TITLE: 'Fallito!',
  OR: 'Oppure',
  EVENT_SETTINGS: 'Impostazioni evento',
  LEADS: 'Potenziali clienti',
  COPIED: 'Copied!',
  PREVIEW: 'Preview',
  RENAME: 'Rename',
  DELETE_LABEL: 'Vuoi eliminare questa'
}
